/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ExamLangsIdMutationRequest,
  PutApiV1ExamLangsIdMutationResponse,
  PutApiV1ExamLangsIdPathParams,
  PutApiV1ExamLangsId401,
  PutApiV1ExamLangsId404,
  PutApiV1ExamLangsId500,
} from "../../types/examEvaluationController/PutApiV1ExamLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ExamLangsId } from "../../clients/examEvaluationController/putApiV1ExamLangsId.ts";

export const putApiV1ExamLangsIdMutationKey = () =>
  [{ url: "/api/v1/exam/langs/:id" }] as const;

export type PutApiV1ExamLangsIdMutationKey = ReturnType<
  typeof putApiV1ExamLangsIdMutationKey
>;

export function putApiV1ExamLangsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1ExamLangsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1ExamLangsIdMutationKey();
  return mutationOptions<
    PutApiV1ExamLangsIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
    >,
    {
      id: PutApiV1ExamLangsIdPathParams["id"];
      data?: PutApiV1ExamLangsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1ExamLangsId(id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de um idioma de prova existente. O CultureInfo deve ser único por prova. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:id}
 */
export function usePutApiV1ExamLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ExamLangsIdMutationResponse,
      ResponseErrorConfig<
        PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
      >,
      {
        id: PutApiV1ExamLangsIdPathParams["id"];
        data?: PutApiV1ExamLangsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1ExamLangsIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1ExamLangsIdMutationKey();

  const baseOptions = putApiV1ExamLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ExamLangsIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
    >,
    {
      id: PutApiV1ExamLangsIdPathParams["id"];
      data?: PutApiV1ExamLangsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1ExamLangsIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
    >,
    {
      id: PutApiV1ExamLangsIdPathParams["id"];
      data?: PutApiV1ExamLangsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ExamLangsIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
    >,
    {
      id: PutApiV1ExamLangsIdPathParams["id"];
      data?: PutApiV1ExamLangsIdMutationRequest;
    },
    TContext
  >;
}
